import type { SVGProps } from 'react';
import { Ref, forwardRef } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgGithubIcon = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps, ref: Ref<SVGSVGElement>) => (
  <svg
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      d="M7.99992 1.30046C11.6833 1.30046 14.6666 4.28379 14.6666 7.96712C14.6662 9.36396 14.2278 10.7255 13.4131 11.8601C12.5984 12.9948 11.4484 13.8453 10.1249 14.2921C9.79159 14.3588 9.66659 14.1505 9.66659 13.9755C9.66659 13.7505 9.67492 13.0338 9.67492 12.1421C9.67492 11.5171 9.46659 11.1171 9.22492 10.9088C10.7083 10.7421 12.2666 10.1755 12.2666 7.61712C12.2666 6.88379 12.0083 6.29212 11.5833 5.82545C11.6499 5.65879 11.8833 4.97545 11.5166 4.05879C11.5166 4.05879 10.9583 3.87545 9.68325 4.74212C9.14992 4.59212 8.58325 4.51712 8.01659 4.51712C7.44992 4.51712 6.88325 4.59212 6.34992 4.74212C5.07492 3.88379 4.51659 4.05879 4.51659 4.05879C4.14992 4.97545 4.38325 5.65879 4.44992 5.82545C4.02492 6.29212 3.76659 6.89212 3.76659 7.61712C3.76659 10.1671 5.31659 10.7421 6.79992 10.9088C6.60825 11.0755 6.43325 11.3671 6.37492 11.8005C5.99159 11.9755 5.03325 12.2588 4.43325 11.2505C4.30825 11.0505 3.93325 10.5588 3.40825 10.5671C2.84992 10.5755 3.18325 10.8838 3.41659 11.0088C3.69992 11.1671 4.02492 11.7588 4.09992 11.9505C4.23325 12.3255 4.66659 13.0421 6.34159 12.7338C6.34159 13.2921 6.34992 13.8171 6.34992 13.9755C6.34992 14.1505 6.22492 14.3505 5.89159 14.2921C4.56378 13.8502 3.40886 13.0013 2.59066 11.866C1.77246 10.7307 1.33252 9.36655 1.33325 7.96712C1.33325 4.28379 4.31659 1.30046 7.99992 1.30046Z"
      fill="currentColor"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgGithubIcon);
export default ForwardRef;
